import React from 'react'
import { useMemo } from 'react';
import { Select } from '../form';

const SelectCustom = ({ valueId, keyName, options, setRow, row, selectText, selectPops, isMulti, onChangeKey, keyIsString, onChangeRow, onChangeAdd, showEnabled, isSort, disabled, customName, fnName, addLegend }) => {
  const cboRecord = useMemo(() => {
    if (!valueId) {
      return ''
    }

    if (isMulti) {
      const selectedItems = [];
      valueId.forEach(it => {
        let finded = options.find(t => {
          if (keyIsString) {
            return it === t[keyName]
          }
          return parseInt(it) === parseInt(t['id_' + keyName])
        });

        if (finded) {
          selectedItems.push({
            label: finded['name_' + keyName],
            value: finded['id_' + keyName]
          })
        }
      })

      if (selectedItems.length === 0) {
        return ''
      }

      return selectedItems;
    } else {
      let finded = options.find(t => {
        if (keyIsString) {
          return t['id_' + keyName] === valueId
        }
        return parseInt(t['id_' + keyName]) === parseInt(valueId)
      });

      if (!finded) {
        return ''
      }

      return {
        label: customName ? fnName(finded) : finded['name_' + keyName],
        value: finded['id_' + keyName]
      };
    }
  }, [valueId, options, keyName, isMulti, keyIsString, customName, fnName])

  const notExistsRecord = useMemo(() => {
    if (!addLegend) {
      return <div></div>
    }

    if (
      (isMulti && valueId.length > 0) ||
      (!isMulti && valueId)
    ) {
      const finded = options.find(t => {
        if (keyIsString) {
          if (showEnabled) {
            return valueId === t['id_' + keyName] && parseInt(t['enabled_' + keyName]) === 1
          } else {
            return valueId === t['id_' + keyName]
          }
        }
        if (showEnabled) {
          return parseInt(valueId) === parseInt(t['id_' + keyName]) && parseInt(t['enabled_' + keyName]) === 1
        } else {
          return parseInt(valueId) === parseInt(t['id_' + keyName])
        }
      });

      if (!finded) {
        return <div className='mb-3'>
          <small className='text-danger'>
            El <strong>{selectText}</strong> seleccionado está <strong>deshabilitado</strong>.
          </small>
        </div>
      } else {
        return <div></div>
      }
    }

    return <div className='col-12 mb-3'></div>
  }, [valueId, options, keyName, selectText, isMulti, keyIsString, showEnabled, addLegend]);

  const optionsList = useMemo(() => {
    const optionsAux = options.filter(t => {
      if (showEnabled) {
        return parseInt(t['enabled_' + keyName]) === 1;
      } else {
        return true;
      }
    })

    if (!isMulti) {
      const finded = options.find(t => {
        if (keyIsString) {
          if (showEnabled) {
            return valueId === t['id_' + keyName] && parseInt(t['enabled_' + keyName]) === 0
          } else {
            return valueId === t['id_' + keyName]
          }
        }
        if (showEnabled) {
          return parseInt(valueId) === parseInt(t['id_' + keyName]) && parseInt(t['enabled_' + keyName]) === 0
        } else {
          return parseInt(valueId) === parseInt(t['id_' + keyName])
        }
      });

      if (showEnabled && finded) {
        optionsAux.push(finded)
      }
    }

    let finalData = optionsAux;

    if (isSort) {
      finalData = optionsAux.sort((t, u) => {
        if (t['name_' + keyName] > u['name_' + keyName]) {
          return 1;
        }

        if (t['name_' + keyName] < u['name_' + keyName]) {
          return -1;
        }

        return 0;
      })
    }

    return finalData.map(t => {
      return {
        label: customName ? fnName(t) : t['name_' + keyName],
        value: t['id_' + keyName],
        isDisabled: showEnabled ? parseInt(t['enabled_' + keyName]) === 0 : false,
        ...t
      }
    })
  }, [valueId, options, keyName, isMulti, keyIsString, showEnabled, isSort, customName, fnName])

  return <>
    <Select
      classNameParent="col-12"
      text={selectText}
      options={optionsList}
      value={cboRecord}
      onChange={e => {
        const auxRow = { ...row };
        if (isMulti) {
          auxRow['p_' + keyName] = e ? e.map(it => {
            return it.value
          }) : []
        } else {
          auxRow[onChangeKey ? onChangeKey : 'p_id_' + keyName] = e.value;
        }

        onChangeRow(e)?.forEach(oe => {
          auxRow[oe.name] = oe.value;
        })

        setRow(auxRow)
        onChangeAdd(e)
      }}
      isMulti={isMulti}
      showNA={!isMulti}
      afterContent={notExistsRecord}
      disabled={disabled}
      {...selectPops}
    />
  </>
}

SelectCustom.defaultProps = {
  selectPops: {},
  isMulti: false,
  onChangeKey: '',
  keyIsString: false,
  onChangeRow: () => [],
  onChangeAdd: () => { },
  showEnabled: true,
  isSort: true,
  disabled: false,
  customName: false,
  fnName: () => { },
  addLegend: true,
}

export default SelectCustom;